const endpoints = {
  GET_THREAD_MESSAGES: (threadId: string) => `/chat-threads/${threadId}`,
  POST_THREAD_MESSAGE: (threadId: string) => `/chat-threads/${threadId}/messages`,
};

export default endpoints;
